module.exports = __webpack_public_path__ + "96300396ed413b82de16b94c34d38a78.pdf";